import {
  AccordionDetails,
  alpha,
  LinearProgress,
  styled,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';

export const LoadingProgressStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90vw',
  height: '30vh',
  gap: 16,
});

export const TableContainerStyled = styled(TableContainer)({
  maxHeight: 680,
  '@media (max-width: 750px)': {
    display: 'none',
  },
  position: 'relative',
});

export const TableCellHeaderWithStickyStyled = styled(TableCell)(
  ({ theme }) => ({
    left: 0,
    height: '62px',
    color: theme.palette.global.white,
    fontWeight: 500,
    fontSize: '14px',
    backgroundColor: theme.palette.primary.main,
    textAlign: 'center',
    position: 'sticky',
    zIndex: 99,
    opacity: 1,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  })
);

export const TableCellHeaderFixedTotalStyled = styled(TableCell)(
  ({ theme }) => ({
    position: 'sticky',
    zIndex: 99,
    left: '200px',
    height: '48px',
    color: theme.palette.global.white,
    fontWeight: 500,
    fontSize: '12px',
    backgroundColor: alpha(theme.palette.primary.main, 1),
    textAlign: 'center',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
    padding: '12px 6px',
    minWidth: '120px',
  })
);

export const TableCellHeaderStyled = styled(TableCell)(({ theme }) => ({
  height: '62px',
  color: theme.palette.global.white,
  fontWeight: 500,
  fontSize: '14px',
  backgroundColor: theme.palette.primary.main,
  textAlign: 'center',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  zIndex: 98,
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  height: '62px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 0.1),
  },
}));

export const ItemNumStyled = styled('span')({
  fontWeight: 600,
  fontSize: '1rem',
  display: 'inline-block',
  width: '40px',
});

export const CellStepsStyled = styled(TableCell)(({ theme }) => ({
  fontSize: '12px',
  position: 'sticky',
  left: '0px',
  zIndex: 97,
  minWidth: '200px',
  backgroundColor: theme.palette.primary.main,
  borderBottom: '1px solid #e0e0e0',
}));

export const TableCellFixedStyled = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  left: '200px',
  border: '1px solid #e0e0e0',
  minWidth: '64px',
  textAlign: 'center',
  fontWeight: 600,
  fontSize: '12px',
  background: 'white',
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 1),
  },
  '&.MuiTableCell-root': {
    padding: '8px 12px',
  },
}));

export const FatherTableCellFixedStyled = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  left: '200px',
  border: '1px solid #e0e0e0',
  zIndex: 97,
  minWidth: '64px',
  textAlign: 'center',
  backgroundColor: theme.palette.primary.main,
  '&.MuiTableCell-root': {
    padding: '8px 12px',
  },
}));

export const TableCellStyled = styled(TableCell)(({ theme }) => ({
  border: '1px solid #e0e0e0',
  minWidth: '64px',
  textAlign: 'center',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 0.1),
  },
  '&.MuiTableCell-root': {
    padding: '10px 16px',
  },
}));

export const LinearProgressStyled = styled(LinearProgress)({
  height: '10px',
  borderRadius: '20px',
});

export const TableCellHeaderFixedStyled = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  zIndex: 99,
  left: '0px',
  height: '48px',
  color: theme.palette.global.white,
  fontWeight: 500,
  fontSize: '12px',
  backgroundColor: alpha(theme.palette.primary.main, 1),
  textAlign: 'center',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  padding: '12px 6px',
  minWidth: '120px',
}));

export const MobileStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'scroll',
  padding: 24,
  '& h4': {
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginBottom: 24,
  },
  '@media(min-width: 751px)': {
    display: 'none',
  },
}));

export const TitleStyled = styled(Typography)({
  textAlign: 'center',
  fontSize: '16px',
  marginBottom: '28px',
});

export const TitleHeaderStyled = styled('div')(({ theme }) => ({
  marginTop: 16,
  '& p': {
    color: theme.palette.global.lightgray,
    fontSize: 13,
  },
}));

export const ValuesStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  '& div': {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: theme.palette.global.lightgray,
    '& p + p': {
      color: '#64A348',
    },
  },
  '& .secondaryColumn': {
    textAlign: 'start',
    width: '30%',
    '& p': {
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      '& svg': {
        color: theme.palette.secondary.main,
      },
    },
  },
}));

export const AccordionDivStyled = styled('div')({
  marginTop: 20,
  '& .MuiAccordionDetails-root': {
    marginTop: -10,
  },
});

export const ProjectStepsStyled = styled('div')(({ theme }) => ({
  width: '100%',
  '& .description': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 12,
    '& p': {
      fontSize: 12,
    },
  },
  '& .conclusion': {
    fontSize: 11,
    color: theme.palette.global.lightgray,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    '& span': {
      fontSize: 11,
      color: theme.palette.primary.main,
    },
  },
}));

export const ItemStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  '& .primaryItem': {
    display: 'flex',
    alignItems: 'center',
    width: '90vw',
    '& p': {
      color: theme.palette.primary.main,
      fontSize: 14,
    },
  },
  '& .secondaryItem': {
    width: '100%',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
    marginLeft: 16,
    '& div': {
      display: 'flex',
      width: '100%',
      '& p': {
        color: theme.palette.secondary.main,
        fontSize: 12,
      },
    },
    '& div + div': {
      width: '60%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 4,
      '& p': {
        fontSize: 11,
        color: theme.palette.global.lightgray,
      },
      '& p + p': {
        color: theme.palette.secondary.main,
      },
    },
  },
}));

export const AccordionDetailsStyled = styled(AccordionDetails)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  '& div': {
    color: theme.palette.global.lightgray,
    '& p': {
      fontSize: 12,
    },
  },
  '& div + div': {
    color: theme.palette.primary.main,
  },
}));

export const DivNoDataStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90%',
  marginLeft: '5%',
});
